export default class UserServices {

	static save(data, onSuccess, onError){
		data.id ? UserServices.update(data, onSuccess, onError) : UserServices.store(data, onSuccess, onError);
	}

	static store(data, onSuccess, onError){
		axios.post(route('api.users.store'), data)
		.then((response) => {
			if (onSuccess) onSuccess(response);
		},({ response }) => {
			if (onError) onError(response);
		});
	}

	static update(data, onSuccess, onError){
		axios.put(route('api.users.update', data.id), data)
		.then((response) => {
			if (onSuccess) onSuccess(response);
		},({ response }) => {
			if (onError) onError(response);
		});
	}

}
